import { phoneCodes } from "../helpers/options";

export const splitPhone = (client) => {
  let phone = client?.phonePrefix + client?.phoneNumber;

  if (phone.startsWith("+58")) {
    phone = phone.slice(3);
  }

  const codes = phoneCodes.map((code) => ({
    name: code.name.replace(/^0+/, ""),
    code: code.code,
    mask: code.mask,
  }));

  let phonePrefix = "";
  let phoneNumber = phone;

  for (const code of codes) {
    if (phone.startsWith(code.name)) {
      phonePrefix = code.name;
      phoneNumber = phone.slice(code.name.length);
      break;
    }
  }

  if (phonePrefix && phonePrefix.length < 4) {
    phonePrefix = "0" + phonePrefix;
  }

  return {
    phonePrefix: phonePrefix,
    phoneNumber: phoneNumber,
  };
};
